import { render, staticRenderFns } from "./TheSessions.vue?vue&type=template&id=3bd66d5c&scoped=true&"
import script from "./TheSessions.vue?vue&type=script&lang=js&"
export * from "./TheSessions.vue?vue&type=script&lang=js&"
import style0 from "./TheSessions.vue?vue&type=style&index=0&id=3bd66d5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd66d5c",
  null
  
)

export default component.exports